import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from './Components/Navbar';
import Herocarousel from './pages/Herocarousel';
import Footer from './Components/Footer';
import Home from "./pages/Home";
import Resources from "./pages/Resources.jsx";
import Contact from "./pages/Contact.jsx";
import About from './pages/About.jsx';
import ScrollToTop from "./Components/ScrollToTop.jsx";
import Scrapservices from "./pages/Scrapservices.jsx";
import IronScrapSection from "./pages/IronScrapSection.jsx";
import AluminiumScrap from "./pages/AluminiumScrap.jsx";
import Services from "./pages/Services.jsx";
import CopperScrap from "./pages/CopperScrap.jsx";
import CarScrap from "./pages/CarScrap.jsx";
import PlasticScrap from "./pages/PlasticScrap.jsx";
import Scrapservices1 from "./pages/Scrapservices1.jsx";
import AIInformation from "./Components/AIInformation";
import FloatingContactButtons from "./Components/WhatsAppButton.jsx";
import HelmetTest from "./Components/HelmetTest";

function App() {
  return (
    <BrowserRouter>
      <FloatingContactButtons />
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/About" element={<About />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/Scrapservices" element={<Scrapservices />} />
        <Route path="/ironScrapSection" element={<IronScrapSection />} />
        <Route path="/services" element={<Services />} />
        <Route path="/AluminiumScrap" element={<AluminiumScrap />} />
        <Route path="/CopperScrap" element={<CopperScrap />} />
        <Route path="/CarScrap" element={<CarScrap />} />
        <Route path="/PlasticScrap" element={<PlasticScrap />} />
        <Route path="/Scrapservices1" element={<Scrapservices1 />} />
        <Route path="/ai-information" element={<AIInformation />} />
        
        {/* Test route - remove after testing */}
        <Route path="/helmet-test" element={<HelmetTest />} />
      </Routes>
      
      <Footer />
    </BrowserRouter>
  );
}

export default App;